import React from "react";
import "./devtool.css";

const LoadingDevtools: React.FC = () => (
  <button className='loading-devtool-toggler'>...</button>
);

export default LoadingDevtools;
